/**
 * pdfPaneMath.js — pure coordinate-transform math for useRasterViewport.js, split into its own
 * dependency-free module (no React import) so it can be unit-tested with a plain node script —
 * the same convention as frontend/src/components/splitView.js / splitView.test.mjs.
 *
 * Coordinate model: screen px (relative to the canvas container) <-> "content" px (the pan/zoom
 * transform's own space, i.e. the base raster canvas's pixel space before the {x,y,z} transform)
 * <-> page-relative visual fraction [fx, fy] in 0..1, derived from the base raster canvas's own
 * pixel dimensions. This is the takeoffs coordinate model (lib/pdfFrame.js, TakeoffEditor.jsx),
 * deliberately NOT the QC tool's absolute-PDF-user-space + page_frame reprojection apparatus —
 * see docs/SUBMITTAL_REVIEW_PLAN.md and useRasterViewport.js's header comment.
 */

/** Pure: screen px (relative to the canvas container) -> page-relative visual fraction [fx, fy]. */
export function screenToFracPure(vp, baseDims, sx, sy) {
  const cx = (sx - vp.x) / vp.z, cy = (sy - vp.y) / vp.z
  if (!baseDims || !baseDims.bw || !baseDims.bh) return [0, 0]
  return [cx / baseDims.bw, cy / baseDims.bh]
}

/** Pure: page-relative visual fraction [fx, fy] -> screen px (relative to the canvas container). */
export function fracToScreenPure(vp, baseDims, fx, fy) {
  if (!baseDims || !baseDims.bw || !baseDims.bh) return [vp.x, vp.y]
  const cx = fx * baseDims.bw, cy = fy * baseDims.bh
  return [cx * vp.z + vp.x, cy * vp.z + vp.y]
}
